import { apiClient } from '@/lib/api-client';

export interface NotificationTemplate {
  TemplateID: string;
  TenantOrganizationID: string | null;
  EventType: string;
  Channel: 'Email' | 'WhatsApp';
  Subject: string | null;
  Body: string;
  SenderProfileID: string | null;
  IsActive: number | boolean;
}

export interface TemplateInput {
  id?: string;
  eventType: string;
  channel: 'Email' | 'WhatsApp';
  subject?: string | null;
  body: string;
  senderProfileId?: string | null;
  isActive?: boolean;
}

export const templatesApi = {
  list(): Promise<NotificationTemplate[]> {
    return apiClient.get('/admin/templates');
  },
  create(input: TemplateInput): Promise<{ id: string }> {
    return apiClient.post('/admin/templates', input);
  },
  update(id: string, input: Omit<TemplateInput, 'id' | 'eventType' | 'channel'>) {
    return apiClient.put(`/admin/templates/${id}`, input);
  },
  remove(id: string) {
    return apiClient.del(`/admin/templates/${id}`);
  },
  preview(body: string, subject: string | null, channel: string) {
    return apiClient.post<{ subject: string | null; rendered: string }>(
      '/admin/templates/preview',
      { body, subject, channel },
    );
  },
  context(): Promise<{ variables: string[]; sample: Record<string, string> }> {
    return apiClient.get('/admin/templates/context');
  },
};

export const EVENT_TYPES = [
  'task_assigned',
  'task_reassigned',
  'task_status_changed',
  'task_updated',
  'task_comment',
  'task_mention',
  'task_completed',
  'task_due_soon',
  'task_overdue',
  'task_recurring_spawned',
  'note_reminder',
  'leave_applied',
  'leave_updated',
  'leave_cancelled',
  'leave_decided',
  'wfh_decided',
] as const;
